export const TOC_ITEMS = [
  { id: "what-is-proxy", label: "What is a Proxy Server?" },
  { id: "how-proxies-work", label: "How Do Proxies Work?" },
  { id: "types-overview", label: "Types of Proxy Server" },
  { id: "proxies-by-ip-source", label: "Proxies by IP Source" },
  { id: "proxies-by-protocol", label: "Proxies by Protocol" },
  { id: "proxies-by-position", label: "Proxies by Position" },
  { id: "proxies-by-access", label: "Proxies by Access" },
  { id: "proxies-by-rotation", label: "Proxies by Rotation" },
  { id: "proxies-by-ip-tech", label: "Proxies by IP Technology" },
  { id: "proxies-by-anonymity", label: "Proxies by Anonymity" },
  { id: "pros-and-cons", label: "Pros & Cons" },
  { id: "conclusion", label: "Conclusion" },
];

export const ACCENT_COLOR = "#5b8cff";

export const POST_TAGS = ["Proxy Servers", "Web Scraping", "Networking", "Anonymity"];
export const ARTICLE_TAGS = [
  "Proxy Servers",
  "Web Scraping",
  "Networking",
  "Anonymity",
  "Residential Proxies",
  "Mobile Proxies",
];
